import { render, staticRenderFns } from "./InventoryTransferRequest.vue?vue&type=template&id=7e737107&"
import script from "./InventoryTransferRequest.vue?vue&type=script&lang=js&"
export * from "./InventoryTransferRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports